import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { from, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { PermissionService } from "../permission.service";

@Injectable({
  providedIn: "root",
})
export class BeaconRegionWriteGuard implements CanActivate {
  constructor(
    private PermissionService: PermissionService,
    private router: Router,
  ) {}

  canActivate(): boolean | Observable<boolean> {
    return from(
      this.PermissionService.categories.beaconRegions.hasWrite(),
    ).pipe(
      map((res) => {
        if (!res) {
          this.router.navigate([""]);
        }
        return res;
      }),
    );
  }
}

@Injectable({
  providedIn: "root",
})
export class BeaconRegionListGuard implements CanActivate {
  constructor(
    private PermissionService: PermissionService,
    private router: Router,
  ) {}

  canActivate(): boolean | Observable<boolean> {
    return from(this.PermissionService.categories.beaconRegions.hasList()).pipe(
      map((res) => {
        if (!res) {
          this.router.navigate([""]);
        }
        return res;
      }),
    );
  }
}

@Injectable({
  providedIn: "root",
})
export class BeaconRegionDetailGuard implements CanActivate {
  constructor(
    private PermissionService: PermissionService,
    private router: Router,
  ) {}

  canActivate(): boolean | Observable<boolean> {
    return from(
      this.PermissionService.categories.beaconRegions.hasDetail(),
    ).pipe(
      map((res) => {
        if (!res) {
          this.router.navigate([""]);
        }
        return res;
      }),
    );
  }
}
